<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="添加资讯"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <div class="tips m-b-20">
      <div class="m-b-10">
        1.首页最多展示5条置顶资讯，如果超出5条置顶，按发布时间取前5条首页展示
      </div>
      <div>
        2.资讯链接如果设置非公众号文章，需要提前前往小程序平台设置区域白名单
      </div>
    </div>
    <el-form
      :model="newsForm"
      ref="newsForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="资讯标题" prop="publishTitle">
        <el-input
          v-model="newsForm.publishTitle"
          placeholder="请输入资讯标题"
        ></el-input>
      </el-form-item>

      <el-form-item label="资讯链接" prop="publishLink">
        <el-input
          v-model="newsForm.publishLink"
          placeholder="请输入资讯链接"
        ></el-input>
      </el-form-item>

      <el-form-item label="发布日期" prop="publishDate">
        <el-date-picker
          v-model="newsForm.publishDate"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
          :picker-options="datePickerOptions"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="资讯封面" prop="publishFileId">
        <image-upload
          :imageUrl.sync="newsForm.publishFileId"
          :editMode="true"
          @success="handleUploadSuccess($event, 'publishFileId')"
          @delete="deleteUpload('publishFileId')"
          :maxSize="5"
          :appendToBody="true"
          :showDel="true"
          :accept="'image/jpeg, image/png'"
        />
      </el-form-item>

      <el-form-item label="置顶" prop="topFlag">
        <el-switch
          v-model="newsForm.topFlag"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="validateForm">保存</el-button>
        <el-button @click="resetForm">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import imageUpload from "@/components/Upload/ImageUpload";
import { savePublish, updatePublish } from "@/api/mpManagement";

export default {
  name: "NewsForm",
  components: {
    imageUpload,
  },
  data() {
    return {
      dialogFormVisible: false,
      flag: "add",
      newsForm: this.getInitialFormState(),
      rules: {
        publishTitle: [
          { required: true, message: "请输入资讯标题", trigger: "blur" },
          { max: 50, message: "最多50个字", trigger: "blur" },
        ],
        publishLink: [
          { required: true, message: "请输入资讯链接", trigger: "blur" },
          { max: 200, message: "最多200个字", trigger: "blur" },
        ],
        publishDate: [
          { required: true, message: "请选择发布日期", trigger: "change" },
        ],
      },
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    getInitialFormState() {
      return {
        publishTitle: "",
        publishLink: "",
        publishDate: "",
        publishFileId: "",
        topFlag: 0,
      };
    },
    validateForm() {
      this.$refs.newsForm.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          this.$message.error("请检查表单输入");
        }
      });
    },
    async submitForm() {
      const { statusCode } =
        this.flag === "add"
          ? await savePublish(this.newsForm)
          : await updatePublish(this.newsForm);

      if (statusCode === 200) {
        this.$message.success("提交成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      }
    },
    resetForm() {
      this.newsForm = this.getInitialFormState();
      this.$refs.newsForm.resetFields();
      this.dialogFormVisible = false;
    },
    openDialog(flag, formData) {
      this.flag = flag;
      this.newsForm =
        flag === "edit" ? { ...formData } : this.getInitialFormState();
      this.dialogFormVisible = true;
      this.$refs.newsForm.resetFields();
    },
    handleUploadSuccess(val, flag) {
      this.newsForm[flag] = val;
    },
    async deleteUpload(flag) {
      this.newsForm[flag] = null;
    },
  },
};
</script>

<style scoped>
.tips {
  font-size: 14px;
}

.app-container {
  padding: 20px;
}

.module-wrap {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/mpManagement/components/addInfoModal.vue